import cn from 'classnames';
import LinkWrapper from 'UI/components/LinkWrapper';
import Svg from 'UI/components/Svg';
import ClutchWidget from 'UI/components/ClutchWidget';
import Image from 'next/image';
import { getContentfulImage } from 'UI/components/Illustration/utils/helpers';
import styles from './styles.module.scss';
import { footerImage } from '../utils/data';

const FooterCenter = () => (
  <div className={styles['footer-body']}>
    <div className={styles['block-1']}>
      <LinkWrapper
        path="/"
        className={styles.logo}
      >
        <Svg type="whiteLogo" />
        <Svg type="whiteYellowText" />
      </LinkWrapper>

      <p className={styles['white-text']}>
        Software innovation powerhouse born to take your business to the top!
      </p>

      <ClutchWidget />
    </div>

    <div className={styles['block-2']}>
      <div className={styles.contentWrapper}>
        <div className={styles['block-2__content']}>
          <LinkWrapper
            path="mailto:hi@yellow.systems"
            className={styles['large-text']}
            target="_blank"
          >
            hi@yellow.systems
          </LinkWrapper>

          <p className={styles['large-text']}>
            +1 (940) 601 6017
          </p>

          <div className={styles['contact-links']}>
            <LinkWrapper
              className={cn(styles['link-text'], styles.bookButton)}
              path="https://calendly.com/yellow-systems-crew/30min"
              target="_blank"
            >
              Book a call
            </LinkWrapper>

            <LinkWrapper
              className={cn(styles['link-text'], styles.chatButton)}
              path="http://wa.me/19406016017"
              target="_blank"
            >
              Chat with us
            </LinkWrapper>
          </div>
        </div>
      </div>

      <div className={styles.contentWrapper}>
        <div className={styles.cityImage}>
          <Image
            src={getContentfulImage({ src: footerImage, format: 'webp', width: 400 })}
            width={200}
            height={71}
            lazyBoundary="200px"
            unoptimized
            loader={(args) => getContentfulImage({ ...args })}
          />
        </div>
        <p className={styles['large-text']}>
          San Francisco, US
        </p>
        <p className={styles['grey-text']}>
          44 Tehama St, CA 94105
        </p>
      </div>
    </div>
  </div>
);

export default FooterCenter;
